import React from 'react'
import { PropTypes } from 'prop-types'
import SiteDisplay from './../../components/SiteDisplay'
import Loading from '../Loading'

const selectNewSite =
  siteSelect =>
    (site) => {
      siteSelect(site)
    }

const SiteList = ({ sites, selectSite, currentSite, loading, history, searched }) => {
  if (loading) return (<Loading />)
  if (!sites || (searched === true && sites.length === 0) || (searched === true && !sites[0].code)) return (<span>No sites found matching your criteria.</span>)
  return (
    <ul className="ln-o-bare-list ln-o-bare-list--spaced">
      {sites.map((site, index) => SiteDisplay(site, index, currentSite, selectNewSite(selectSite, history.push)))}
    </ul>
  )
}

SiteList.propTypes = {
  sites: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectSite: PropTypes.func.isRequired,
  currentSite: PropTypes.shape({
    other_name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired
  }).isRequired,
  loading: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  searched: PropTypes.bool.isRequired
}

SiteList.defaultProps = {
  currentSite: null,
  loading: false,
  searched: false
}

export default SiteList



// WEBPACK FOOTER //
// ./src/components/SiteList/SiteList.jsx